import { computed } from 'mobx';

export default class DataExportModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.updateFromJson(item);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      url: this.url,
      raw_data_id: this.raw_data_id,
      raw_data_end: this.raw_data_end,
      status: this.status,

      origins: this.origins || [],
      parameters: this.parameters || [],
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.url = json.url;
    this.raw_data_id = json.raw_data_id;
    this.raw_data_end = json.raw_data_end;
    this.status = json.status;

    this.origins = json.origins || [];
    this.parameters = json.parameters || [];
  }
}



// WEBPACK FOOTER //
// ./src/models/DataDelivery/RawDataExportModel.js